export enum MultilayerBagsFields {
  type = "type",
  length = "length",
  width = "width",
  folding = "folding",
  // "minigrip-slider" = "minigrip-slider",
  // euro = "euro",
  // tear = "tear",
  // window = "window",
  // butterfly = "butterfly",
  // cap = "cap",
  // handles = "handles",
  mainColor = "mainColor",
  packageableProduct = "packageableProduct",
  printSelect = "printSelect",
  designFile = "designFile",
  amountPcs = "amountPcs",
  typeAdditional = "typeAdditional",
}
